document.addEventListener("alpine:init", () => {
    Alpine.data("scrollingTextHighlight", (autoplay) => ({
        visible: false,
        scrolling: false,

        init() {},
    }));
});
